(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-line-item"] && !Shopify.designMode) return;
  try {
    class AstralCartLineItem extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;
      this.lineKey = this.dataset.lineKey;
      this.quantity = parseInt(this.dataset.quantity);

      // Bind event listeners
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const target = event.target.closest('button');
      if (!target) return;

      if (target.classList.contains('qty-increase')) {
        this.updateQuantity(this.quantity + 1);
      } else if (target.classList.contains('qty-remove')) {
        this.updateQuantity(Math.max(0, this.quantity - 1));
      } else if (target.classList.contains('remove')) {
        this.removeItem();
      }
    }

    async updateQuantity(newQuantity) {
      // Emit updating event
      document.dispatchEvent(
        new CustomEvent('astral-cart-updating', {
          detail: { variantId: this.variantId, quantity: newQuantity },
        })
      );

      try {
        const formData = {
          updates: {
            [this.lineKey]: newQuantity,
          },
        };

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        const cart = await response.json();

        // Update local quantity
        this.quantity = newQuantity;
        this.dataset.quantity = newQuantity;

        // Update display
        const qtyDisplay = this.querySelector('.qty-display');
        if (qtyDisplay) {
          qtyDisplay.textContent = newQuantity;
        }

        // If quantity is 0, remove the item from DOM
        if (newQuantity === 0) {
          this.remove();
        }

        // Emit updated event
        document.dispatchEvent(
          new CustomEvent('astral-cart-updated', {
            detail: { cart, variantId: this.variantId, quantity: newQuantity },
          })
        );
      } catch (error) {
        console.error('Error updating cart:', error);
        // Emit error event
        document.dispatchEvent(
          new CustomEvent('astral-cart-error', {
            detail: { error: error.message, variantId: this.variantId },
          })
        );
      }
    }

    async removeItem() {
      this.updateQuantity(0);
    }
  }

  // Register the custom element
  if (!customElements.get('astral-cart-line-item')) {
    customElements.define('astral-cart-line-item', AstralCartLineItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-main"] && !Shopify.designMode) return;
  try {
    class AstralCart extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.isUpdating = false;

      // Bind event listeners
      this.handleCartUpdating = this.handleCartUpdating.bind(this);
      this.handleCartUpdated = this.handleCartUpdated.bind(this);

      // Listen for cart events
      document.addEventListener('astral-cart-updating', this.handleCartUpdating);
      document.addEventListener('astral-cart-updated', this.handleCartUpdated);
    }

    disconnectedCallback() {
      // Clean up event listeners when element is removed
      document.removeEventListener('astral-cart-updating', this.handleCartUpdating);
      document.removeEventListener('astral-cart-updated', this.handleCartUpdated);
    }

    handleCartUpdating(event) {
      console.log('Cart updating:', event.detail);
      this.showUpdatingState();
    }

    async handleCartUpdated(event) {
      console.log('Cart updated:', event.detail);

      try {
        // Refetch the cart section using Section Rendering API
        await this.refetchCartSection();
      } catch (error) {
        console.error('Error refetching cart section:', error);
      } finally {
        this.hideUpdatingState();
      }
    }

    showUpdatingState() {
      if (this.isUpdating) return;

      this.isUpdating = true;

      // Add pulse animation class
      this.classList.add('opacity-50', 'pointer-events-none');

      // Add CSS animation for pulse effect
      this.style.animation = 'pulse 1.5s ease-in-out infinite';

      // Add pulse keyframes if not already present
      if (!document.getElementById('astral-pulse-styles')) {
        const style = document.createElement('style');
        style.id = 'astral-pulse-styles';
        style.textContent = `
          @keyframes pulse {
            0%, 100% { opacity: 0.5; }
            50% { opacity: 0.8; }
          }
        `;
        document.head.appendChild(style);
      }
    }

    hideUpdatingState() {
      this.isUpdating = false;

      // Remove pulse animation and opacity classes
      this.classList.remove('opacity-50', 'pointer-events-none');
      this.style.animation = '';
    }

    async refetchCartSection() {
      try {
        const sectionId = this.sectionId || 'cart';
        const response = await fetch(`${window.Shopify.routes.root}?sections=${sectionId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch cart section');
        }

        const data = await response.json();
        const newCartHTML = data[sectionId];

        if (newCartHTML) {
          // Create a temporary container to parse the new HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = newCartHTML;

          // Find the new astral-cart element
          const newCartElement = tempDiv.querySelector('astral-cart');

          if (newCartElement) {
            // Replace the inner content while preserving the custom element wrapper
            this.innerHTML = newCartElement.innerHTML;

            // Update data attributes if they changed
            if (newCartElement.dataset.sectionId) {
              this.dataset.sectionId = newCartElement.dataset.sectionId;
            }
          }
        }

        console.log('Cart section refetched successfully');
      } catch (error) {
        console.error('Error in refetchCartSection:', error);
        throw error;
      }
    }
  }

  // Register the custom element
  if (!customElements.get('astral-cart')) {
    customElements.define('astral-cart', AstralCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-minicart"] && !Shopify.designMode) return;
  try {
    class AstralMiniCart extends HTMLElement {
    constructor() {
      super();

      // Get DOM elements
      this.overlay = this.querySelector('[data-cart-overlay]');
      this.panel = this.querySelector('[data-cart-panel]');
      this.closeButton = this.querySelector('[data-cart-close]');
      this.contentContainer = this.querySelector('[data-cart-content]');

      // Bind methods
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.handleOpenCart = this.handleOpenCart.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleHypeItemAdded = this.handleHypeItemAdded.bind(this);

      // Set up event listeners
      this.setupEventListeners();
    }

    setupEventListeners() {
      // Listen for open cart event
      document.addEventListener('astral-open-cart', this.handleOpenCart);
      document.addEventListener('hype:item-added-to-cart', this.handleHypeItemAdded);

      // Close button click
      this.closeButton.addEventListener('click', this.handleCloseClick);

      // Overlay click to close
      this.overlay.addEventListener('click', this.handleOverlayClick);

      // Escape key to close
      document.addEventListener('keydown', this.handleKeyDown);
    }

    disconnectedCallback() {
      // Clean up event listeners
      document.removeEventListener('astral-open-cart', this.handleOpenCart);
      document.removeEventListener('hype:item-added-to-cart', this.handleHypeItemAdded);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleHypeItemAdded(event) {
      this.handleOpenCart({
        detail: {
          source: 'hype:item-added-to-cart',
          hypeDetail: event?.detail ?? null,
        },
      });
    }

    handleOpenCart(event) {

      // Emit event to trigger cart reload (handled by cart-main.liquid)
      document.dispatchEvent(
        new CustomEvent('astral-cart-updated', {
          detail: { source: 'mini-cart-open' },
        })
      );

      // Open the mini cart
      this.open();
    }

    open() {
      // Show the mini cart but keep it invisible initially
      this.classList.remove('hidden');

      // Ensure initial state is set (off-screen)
      this.overlay.classList.remove('opacity-100');
      this.overlay.classList.add('opacity-0');
      this.panel.classList.remove('translate-x-0');
      this.panel.classList.add('translate-x-full');

      // Force reflow to ensure initial state is applied
      this.offsetHeight;

      // Animate in after a small delay to ensure initial state is rendered
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.overlay.classList.remove('opacity-0');
          this.overlay.classList.add('opacity-100');
          this.panel.classList.remove('translate-x-full');
          this.panel.classList.add('translate-x-0');
        });
      });

      // Prevent body scroll
      document.body.style.overflow = 'hidden';

      // Focus management after animation starts
      setTimeout(() => {
        this.closeButton.focus();
      }, 50);
    }

    close() {
      // Animate out
      this.overlay.classList.remove('opacity-100');
      this.overlay.classList.add('opacity-0');
      this.panel.classList.remove('translate-x-0');
      this.panel.classList.add('translate-x-full');

      // Hide after animation
      setTimeout(() => {
        this.classList.add('hidden');
        // Restore body scroll
        document.body.style.overflow = '';
      }, 300);
    }

    handleCloseClick(event) {
      event.preventDefault();
      this.close();
    }

    handleOverlayClick(event) {
      if (event.target === this.overlay) {
        this.close();
      }
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && !this.classList.contains('hidden')) {
        this.close();
      }
    }
  }

  // Register the custom element
  if (!customElements.get('astral-mini-cart')) {
    customElements.define('astral-mini-cart', AstralMiniCart);
    console.log('AstralMiniCart custom element registered');
  }

  // Helper function to open mini cart (for testing)
  window.openMiniCart = function () {
    console.log('Attempting to open mini cart...');
    const miniCart = document.querySelector('astral-mini-cart');
    if (miniCart) {
      console.log('Mini cart element found, dispatching event');
      document.dispatchEvent(
        new CustomEvent('astral-open-cart', {
          detail: { source: 'manual-trigger' },
        })
      );
    } else {
      console.error('Mini cart element not found in DOM');
    }
  };

  // Ensure DOM is ready before setting up event listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM loaded, mini cart should be ready');
      const miniCart = document.querySelector('astral-mini-cart');
      console.log('Mini cart element:', miniCart);
    });
  } else {
    console.log('DOM already loaded, mini cart ready');
    const miniCart = document.querySelector('astral-mini-cart');
    console.log('Mini cart element:', miniCart);
  }
  } catch(e) { console.error(e); }
})();

})();
